import { propsDecorator, extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import moment from 'moment';
import sociomanticManager from '@/js/common/Domain/Service/sociomantic';
import ecommerceService from '@/js/common/Domain/Service/ecommerce';
import foundSimilarTourAndSlice from '@/js/common/Domain/Service/foundSimilarTourAndSlice';
import HotelPageFilterCriteria from '@/js/common/Domain/Model/hotelPage/HotelPageFilterCriteria';
import HotelPageModel from '@/js/common/Domain/Service/hotelSearch/HotelPageModel';
import groupProductsByCriterias from '@/js/common/Domain/Service/groupProductsByCriterias';
import computedsFields from './commonFieldsSearchModel/computedsFields';
import defaultsFields from './commonFieldsSearchModel/defaultsFields';
import {operators} from "@fr/constants";

@propsDecorator({
    defaults: {
        ...defaultsFields,
    },
})
@extendDecorator({
    computeds: {
        ...computedsFields,
    },
})
export default class TourSearchModel extends HotelPageModel {
    calculateIsExclusive(groupedTourProducts, tourProducts) {
        _.each(tourProducts?.models, (tourProduct) => {
            tourProduct.set('isExclusive', false);
        });

        if (groupedTourProducts?.length > 0) {
            _.each(groupedTourProducts, (tourProductsGroup, index) => {
                const groupedTourProduct = tourProductsGroup[0];
                const isHotelOffer = groupedTourProduct?.get('type') === 'HotelOfferProduct';

                if (isHotelOffer) {
                    return;
                }

                const isStandarted = !!(groupedTourProduct?.get('tour')?.get('room')?.categoryId) || !!(groupedTourProduct?.get('tour')?.get('room')?.category);
                const tourOperatorId = groupedTourProduct?.get('tour')?.get('operator')?.id;
                const isExclusive = operators.MY_AGENT.includes(tourOperatorId)  && (index === 0 || isStandarted);
                groupedTourProduct.set('isExclusive', isExclusive);
            });
        }
    }

    updateTourProductsCollection(tourProducts) {
        const filteredTourProductsWithSimilarTours = foundSimilarTourAndSlice(tourProducts);
        this.set({ filteredTourProductsWithSimilarTours });
        this.collectionTourSearch?.reset?.();
        this.set('pageNumber', 1, { silent: true });
        this.incCollection();
        this.recompute('pageIncAvaliable');
        this.recompute('toursLost');
    }

    filteredTourProductsChanged() {
        const groupedTourProducts = groupProductsByCriterias(this.get('filteredTourProductsAll'));
        if (!this.get('filterCriteria').get('operators').length && !this.get('filterCriteria').get('block')) {
            this.groupedTourProducts = groupedTourProducts;
            this.set({ groupedTourProducts });
        }
        this.updateTourProductsCollection(this.get('filteredTourProducts'));
    }

    incCollection() {
        const numOfTourPerPage = this.get('numOfTourPerPage');
        const pageNumber = this.get('pageNumber');
        const tourProducts = this.get('filteredTourProductsWithSimilarTours');
        let addTourProducts = [];

        if (tourProducts && tourProducts.length) {
            addTourProducts = tourProducts.slice((pageNumber - 1) * numOfTourPerPage, numOfTourPerPage * pageNumber);
            this.collectionTourSearch.add(addTourProducts);
            this.callECommerce(addTourProducts);
        }
    }

    filterTourProductsByDate(tourProducts, selectedTabDate) {
        if (!tourProducts?.length) return [];
        return tourProducts.filter((tourProduct) => {
            const date = this.getFromDate(tourProduct);
            return moment(date).format('YYYY-MM-DD') === selectedTabDate;
        });
    }

    changedSyncTourProducts() {
        let cheapestModel;
        let sociomanticTimeout;
        const tourProducts = this.get('syncTourProducts');
        let searchFormModelTourCriteria = null;

        if (tourProducts?.length && this.view !== undefined) {
            searchFormModelTourCriteria = this.view.searchFormModel.getTourCriteria();
        }

        if (searchFormModelTourCriteria && searchFormModelTourCriteria.get('countries') && searchFormModelTourCriteria.get('resorts') && tourProducts.length > 0) {
            cheapestModel = tourProducts.min((element) => element.get('product')?.get('price'));

            const departureCity = searchFormModelTourCriteria.get('departureCity').get('name');
            const country = searchFormModelTourCriteria.get('countries').at(0).get('name');
            const resorts = searchFormModelTourCriteria.get('resorts');
            const resortModel = resorts?.at(0) || null;
            const resortName = resortModel?.get('name') || '';
            const product = cheapestModel.get('product');
            const nbra = parseInt(product.get('touristGroup').adults, 10);
            const nbrc = product.get('touristGroup').kids;
            const nbri = product.get('touristGroup').infants || 0;
            const checkinDate = moment(searchFormModelTourCriteria.get('checkInDateRange').get('from')).format('YYYY-MM-DD');
            const checkoutDate = moment(searchFormModelTourCriteria.get('checkInDateRange').get('to')).format('YYYY-MM-DD');

            const price = cheapestModel.get('finalPrice');
            if (typeof (window.APRT_SEND) !== 'undefined') {
                window.APRT_SEND({
                    pageType: 2,
                    searchTickets: {
                        type: 'hotel',
                        class: window.appConfig.hotelInfo.class,
                        from: departureCity,
                        country,
                        dest: resortName,
                        dateFrom: checkinDate,
                        dateTill: checkoutDate,
                        count: nbra,
                        countChildren: nbrc,
                        countBaby: nbri,
                    },
                    currentProduct: {
                        id: window.appConfig.hotelInfo.id,
                        name: window.appConfig.hotelInfo.name,
                        price,
                    },
                });
            }

            sociomanticTimeout = setInterval(() => {
                clearInterval(sociomanticTimeout);
                sociomanticManager.notifyHotelPage(cheapestModel, this.get('searchData'));
            }, 100);
        }
    }

    getFromDate(model) {
        if ((model.get('type') === 'TourProduct' || model.get('type') === 'RailwayTourProduct')
            && model.get('product').get('routes').length && model.get('product').get('routes')[0].there?.legs?.[0].departureDate
        ) {
            return model.get('product').get('routes')[0].there.legs[0].departureDate.substr(0, 10); //to cut time
        }
        return model.get('product').get('checkInDate');
    }

    initModelEvents() {
        this.on('change:pageNumber', this.incCollection.bind(this));
        this.on('change:syncTourProducts', this.changedSyncTourProducts.bind(this));
        this.on('change:filteredTourProducts', this.filteredTourProductsChanged.bind(this));
        this.get('filterCriteria').on('change:selectedTabDate', () => this.recompute('filteredTourProducts'));
        this.get('filterCriteria').on('change:productType change:operators change:isExclusive change:meals change:block', () => {
            this.recompute('filteredTourProductsAll')
        });
    }

    callECommerce(newTourProducts) {
        ecommerceService.hotelImpressions({
            collection: this.collectionTourSearch,
            hotelInfo: window.appConfig.hotelInfo,
            tourProducts: newTourProducts,
            category: 'tour',
            pageType: 'tour',
            departureCityName: this.get('departureCityName'),
        });
    }

    initialize(options) {
        this.collectionTourSearch = options.tourProductsCollection;
        this.set('filterCriteria', new HotelPageFilterCriteria());
        this.initModelEvents();
    }
}
